angular.module('wbDashboard').controller('FormulasControllerAurea',
    ['$scope', '$uibModal', '$filter', 'NgTableParams', 'FormulaService', 'User', 'Account', 'PlanService', 'RiskScore', 'Message',
function ($scope, $uibModal, $filter, NgTableParams, FormulaService, User, Account, PlanService, RiskScore, Message) {

    $scope.pageData = {
        errorMsg: null,
    };
    $scope.forms = {};
    $scope.wallet = false;
    $scope.walletMS = false;
    $scope.FS = FormulaService;

    $scope.enableFormulas = function() {
        $scope.pageData.sending = true;
        FormulaService.enable().finally(function() {
            $scope.pageData.sending = false;
        });
    };

    $scope.$watch(() => { return User.getOverview(); }, function(overview) {
        if (overview) {
            $scope.overview = overview;
        }
    });

    $scope.$watch(() => { return User.getMilestoneByType('wallet'); }, function(wallet) {
        if (wallet) {
            $scope.walletMS = wallet;
        }
    });
    $scope.$watch(function() { return [FormulaService.user.getFormulas(), FormulaService.user.getWallet()]; }, function(data) {
        var [formulas, wallet] = data;
        if (formulas && wallet) {
            $scope.userFormulas = formulas;
            $scope.wallet = wallet;

            setWalletFlashMessage();
        }
    }, true);

    FormulaService.retrieveFormulas();
    $scope.$watch(() => { return FormulaService.getFormulas(); }, (formulas) => {
        $scope.formulas = formulas;
    });

    $scope.milestoneChoices = null;
    $scope.$watchCollection(function() { return User.getMilestones(); }, function(milestones) {
        if (milestones) {
            $scope.milestoneChoices = {};
            angular.forEach(milestones, function(ms) {
                ms.extra.portfolioName = PlanService.user.getPortfolioName(ms.allocation.allocation_model);
                if (!ms.type_account) {
                    $scope.milestoneChoices[ms.id] = ms;
                }
            });
        }
    });

    User.retrieveBankAccounts();
    $scope.$watch(User.getBankAccounts, function(bankAccounts) {
        if (bankAccounts) {
            $scope.bankAccounts = bankAccounts;
            $scope.bankAccounts.current = $scope.bankAccounts.active || $scope.bankAccounts.pending;
        }
    });


    var activityFilter = {page_start:0, page_max:6, type: 'formula'};
    User.retrieveActivity(activityFilter);
    $scope.$watch(function() { return User.getActivity(activityFilter); }, function(activity) {
        if (activity && activity.logs) {
            $scope.activityDateGrouped = User.groupActivityByDate(activity.logs);
        }
    });

    RiskScore.retrievePortfolios();
    $scope.riskPortfolios = null;
    $scope.$watch(function() { return RiskScore.getPortfolios(); }, function(portfolios) {
        if (portfolios) {
            $scope.riskPortfolios = angular.copy(portfolios);
        }
    });

    //needed for confirmation page date
    $scope.$watch(function() { return PlanService.user.getAutos(); }, function(autos) {
        $scope.autos = autos;
    });

    function setWalletFlashMessage() {
        if ($scope.wallet && $scope.$state.current.name === 'base.formulas') {
            if ($scope.wallet.status === 'low-balance') {
                Message.add({
                    key: "walletAlert",
                    text: `Your cash is low!
                            <a data-ui-state="'base.funding.transfer'"
                               data-ui-state-params="{msId:'${$scope.walletMS.id}', type:'deposit', pageStart:'amount'}"
                            >Make a deposit</a>
                            or
                            <a ui-sref="base.formulas.wallet-edit">increase your auto-deposit</a>.`,
                    type: "warning",
                    timeout: false
                });
            }
            if ($scope.wallet.status === 'blocked') {
                Message.add({
                    key: "walletAlert",
                    text: `You don't have enough cash to power formulas!
                            <a data-ui-state="'base.funding.transfer'"
                               data-ui-state-params="{msId:'${$scope.walletMS.id}', type:'deposit', pageStart:'amount'}"
                            >Make a deposit</a>.`,
                    type: "danger",
                    timeout: false
                });
            }
        }
    }

    var transitionDeregisterHook = $scope.$transitions.onSuccess({to: 'base.formulas.**'}, function(trans) {
        if (trans.to().name === 'base.formulas') {
            setWalletFlashMessage();
        } else {
            Message.clear('walletAlert');
        }
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
        Message.clear('walletAlert');
    });
}]);
